import { combineReducers } from 'redux'

import app from './app'
import menus from './menus'
import pages from './pages'
import settings from './settings'
import slideshows from './slideshows'
import slides from './slides'
import interactiveelements from './interactiveelements'
import contentdisplays from './contentdisplays'
import modals from './modals'

const demoApp = combineReducers({
  app,
  menus,
  pages,
  settings,
  slideshows,
  slides,
  interactiveelements,
  contentdisplays,
  modals
})

export default demoApp



// WEBPACK FOOTER //
// ./src/reducers/index.js